<template lang="pug">
  v-dialog(v-model='dialog' persistent='' max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='6' sm='6' md='3' v-if="editedIndex === -1")
                    v-autocomplete(dense outlined :readonly='read' v-model='form.agencia' label='Agencia' :items='agenciaArray' @change="changeAgencia")
                  v-col(cols='6' sm='6' md='3' v-else)
                    v-autocomplete(dense outlined :readonly='read' v-model='form.agencia._id' label='Agencia' :items='agenciaArray')
                  v-col(cols='6' sm='6' md='3' v-if="editedIndex === -1")
                    v-autocomplete(dense outlined :readonly='read' v-model='form.naviera' label='Naviera' :items='navieraArray' @change="changeNaviera")
                  v-col(cols='6' sm='6' md='3' v-else)
                    v-autocomplete(dense outlined :readonly='read' v-model='form.naviera._id' label='Naviera' :items='navieraArray')
                  v-col(cols='6' sm='6' md='3' v-if="editedIndex === -1")
                    v-autocomplete(dense outlined :readonly='read' v-model='form.pais' label='País' :items='paisArray' @change="changePais")
                  v-col(cols='6' sm='6' md='3' v-else)
                    v-autocomplete(dense outlined :readonly='read' v-model='form.pais._id' label='País' :items='paisArray' @change="changePais")
                  v-col(cols='6' sm='6' md='3')
                    v-autocomplete(dense outlined :readonly='read' v-model='form.puerto' label='Puerto' :items='puertoArray')
                v-row(dense)
                  v-col(cols='6' sm='6' md='4')
                    v-text-field(dense outlined :readonly='read' type='number' min="0" v-model='form.diasLibres' label='Días Libres')
                  v-col(cols='6' sm='6' md='4' v-if="!read")
                    v-dialog(ref='dialogSalida' v-model='modalSalida' :return-value.sync='date' persistent width='300px')
                      template(v-slot:activator='{ on }')
                        v-text-field(dense outlined style='margin-bottom: -13px;' label='Fecha de Salida' v-model='form.salida' prepend-inner-icon='event' v-on='on')
                      v-date-picker( v-model='form.salida' locale="ES")
                        v-spacer
                        v-btn(small dark color='red' @click='modalSalida = false') Cancelar
                        v-btn(small dark color='success' @click='$refs.dialogSalida.save(date)') Ok
                  v-col(cols='6' sm='6' md='4' v-else)
                    v-text-field(dense outlined readonly style='margin-bottom: -13px;' label='Fecha de Salida' v-model='form.salida' prepend-inner-icon='event')
                  v-col(cols='6' sm='6' md='4')
                    v-text-field(dense outlined :readonly='read' type='number' min="0" v-model='form.transito' label='Tránsito')
                v-row(dense)
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' type='number' min="0" v-model='form.flete' label='Flete' prefix="$")
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' type='number' min="0" v-model='form.gastos' label='Gastos Locales' prefix="$")
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' type='number' min="0" v-model='form.depositoG' label='Depósito de Garantía')
                  v-col(cols='6' sm='6' md='3')
                    v-autocomplete(dense outlined :readonly='read' v-model='form.estatusDepositoG' label='Estatus del Depósito' :items='depositoArray')
                v-row(dense class='d-flex justify-end')
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined readonly v-model='form.totalTarifa' label='Total Tarifa' prefix="$")
                v-row(dense)
                  v-col(cols='12' sm='12' md='12')
                    v-textarea(auto-grow dense outlined :readonly='read' v-model='form.observacion' label='Observación')
      v-card-actions
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-spacer
        v-btn(v-if='!read' color='success' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    dialogSalida: false,
    modalSalida: false,
    dialogLoading: false,
    search: '',
    navieras: [],
    navieraAgencia: [],
    agenciaArray: [],
    navieraArray: [],
    pais: [],
    paisArray: [],
    puertoArray: [],
    depositoArray: ['Ex', 'No Ex'],
    form: {
      agencia: [],
      naviera: [],
      pais: [],
      puerto: null,
      flete: 0,
      gastos: 0,
      diasLibres: 0,
      depositoG: 0,
      estatusDepositoG: '',
      salida: '',
      transito: 0,
      observacion: '',
      totalTarifa: 0
    },
    defaultForm: {
      agencia: [],
      naviera: [],
      pais: [],
      puerto: null,
      flete: 0,
      gastos: 0,
      diasLibres: 0,
      depositoG: 0,
      estatusDepositoG: '',
      salida: '',
      transito: 0,
      observacion: '',
      totalTarifa: 0
    }
  }),

  components: {
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Tarifa'
        : this.read
          ? 'Información de la Tarifa'
          : 'Modificar Tarifa'
    }
  },

  watch: {
    FormPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = val
        if (this.form.pais) { this.changePais(this.form.pais._id) }
      }
    },
    'form.flete': function (val) {
      if (val && val !== '') {
        val = parseFloat(val)
        this.form.gastos !== '' ? this.form.gastos = parseFloat(this.form.gastos) : this.form.gastos = 0
        this.form.depositoG !== '' ? this.form.depositoG = parseFloat(this.form.depositoG) : this.form.depositoG = 0
        let to = val + this.form.gastos + this.form.depositoG
        this.form.totalTarifa = to.toFixed(2)
      } else {
        this.form.gastos !== '' ? this.form.gastos = parseFloat(this.form.gastos) : this.form.gastos = 0
        this.form.depositoG !== '' ? this.form.depositoG = parseFloat(this.form.depositoG) : this.form.depositoG = 0
        let to = this.form.gastos + this.form.depositoG
        this.form.totalTarifa = to.toFixed(2)
      }
    },
    'form.gastos': function (val) {
      if (val && val !== '') {
        val = parseFloat(val)
        this.form.flete !== '' ? this.form.flete = parseFloat(this.form.flete) : this.form.flete = 0
        this.form.depositoG !== '' ? this.form.depositoG = parseFloat(this.form.depositoG) : this.form.depositoG = 0
        let to = val + this.form.flete + this.form.depositoG
        this.form.totalTarifa = to.toFixed(2)
      } else {
        this.form.flete !== '' ? this.form.flete = parseFloat(this.form.flete) : this.form.flete = 0
        this.form.depositoG !== '' ? this.form.depositoG = parseFloat(this.form.depositoG) : this.form.depositoG = 0
        let to = this.form.flete + this.form.depositoG
        this.form.totalTarifa = to.toFixed(2)
      }
    },
    'form.depositoG': function (val) {
      if (val && val !== '') {
        val = parseFloat(val)
        this.form.flete !== '' ? this.form.flete = parseFloat(this.form.flete) : this.form.flete = 0
        this.form.gastos !== '' ? this.form.gastos = parseFloat(this.form.gastos) : this.form.gastos = 0
        let to = val + this.form.flete + this.form.gastos
        this.form.totalTarifa = to.toFixed(2)
      } else {
        this.form.flete !== '' ? this.form.flete = parseFloat(this.form.flete) : this.form.flete = 0
        this.form.gastos !== '' ? this.form.gastos = parseFloat(this.form.gastos) : this.form.gastos = 0
        let to = this.form.flete + this.form.gastos
        this.form.totalTarifa = to.toFixed(2)
      }
    }
  },

  created () {
    this.permisosImportacion = this.$store.state.usuario.Empresa[0].permisos.find(permiso => permiso.ruta === 'Importacion')
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarNaviera()
      this.listarPaises()
    },

    listarPaises () {
      Api.get('/paisesImportacion')
        .then(response => {
          this.pais = response.data
          this.pais.map(data => {
            this.paisArray.push({
              text: data.pais,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarNaviera () {
      Api.get('/naviera')
        .then(response => {
          let arrayAgencia = []
          let arrayNaviera = []
          response.data.map(data => {
            data.tipoN.map(tip => {
              if (tip.includes('Agencia de Carga Internacional')) {
                arrayAgencia.push(data)
                this.agenciaArray.push({
                  text: data.nombreEmpresa,
                  value: data._id
                })
              }
              if (tip.includes('Naviera')) {
                arrayNaviera.push(data)
                this.navieraArray.push({
                  text: data.nombreEmpresa,
                  value: data._id
                })
              }
            })
          })
          this.navieraAgencia = arrayAgencia
          this.navieras = arrayNaviera
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor, verique su conexión de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    changeAgencia (data) {
      const agenciaSelec = this.navieraAgencia.find(agenciaSelec => agenciaSelec._id === data)
      this.form.agencia = agenciaSelec._id
    },

    changeNaviera (data) {
      const navieraSelec = this.navieras.find(navieraSelec => navieraSelec._id === data)
      this.form.naviera = navieraSelec._id
    },

    changePais (data) {
      const pt = this.pais.find(pt => pt._id === data)
      this.puertoArray = []
      for (let i = 0; i < pt.puertos.length; i++) {
        this.puertoArray.push(pt.puertos[i].nombrePuerto)
      }
    },

    formato (fecha) {
      return fecha.slice(0, 10)
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
      }, 300)
      this.$emit('close')
    },

    validarCampos () {
      if (this.form.agencia.length === 0 || this.form.naviera === 0 || this.form.pais === 0 || this.form.puerto === null || this.form.diasLibres === 0 ||
          this.form.flete === 0 || this.form.gastos === 0 || this.form.estatusDepositoG === '' ||
          this.form.salida === '' || this.form.transito === 0) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor, llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        console.log('FORM', this.form)
        if (this.editedIndex > -1) {
          Api.put('tarifa', this.form)
            .then(response => {
              this.$emit('edited')
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modiicar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          Api.post('tarifa', this.form)
            .then(response => {
              this.$emit('save')
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
